import Controller from "@ember/controller"

export default class AdminUserController extends Controller {
  queryParams = ["sidebar"]
}
